if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

 show(opener) {
  // 🔒 LOCK: freeze page without layout shift
  const scrollY = window.scrollY || document.documentElement.scrollTop;
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

  this._scrollLock = {
    scrollY,
    originalPaddingRight: document.body.style.paddingRight || '',
    originalScrollBehavior: document.documentElement.style.scrollBehavior || '',
  };

  if (scrollbarWidth > 0) {
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  }

  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
  document.body.style.overflow = 'hidden';

  // ⬇️ your existing logic stays intact
  opener.setAttribute('aria-disabled', true);
  opener.classList.add('loading');
  opener.querySelector('.loading__spinner').classList.remove('hidden');

  fetch(opener.getAttribute('data-product-url'))
    .then((response) => response.text())
    .then((responseText) => {
      const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
      const productElement = responseHTML.querySelector('product-info');

      this.preprocessHTML(productElement);

      // 🔒 avoid duplicate global declarations
      productElement.querySelectorAll('script').forEach((s) => s.remove());

      // inject into the modal
      HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

      // init controls inside the modal only
      if (typeof initFlavorDropdown === 'function') {
        initFlavorDropdown(this.modalContent);
      }

      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }
      if (window.ProductModel) window.ProductModel.loadShopifyXR();

      super.show(opener);
    })
    .finally(() => {
      opener.removeAttribute('aria-disabled');
      opener.classList.remove('loading');
      opener.querySelector('.loading__spinner').classList.add('hidden');
    });
}

hide(preventFocus = false) {
  const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const opener = this.openedBy;

  // Clear modal content (your original)
  if (cartNotification) cartNotification.setActiveElement(opener);
  this.modalContent.innerHTML = '';

  if (preventFocus) this.openedBy = null;

  // ✅ UNLOCK & RESTORE without any jump
  const lockedTop = parseInt(document.body.style.top || '0', 10);
  const restoreY = Math.abs(lockedTop);
  const originalPaddingRight = this._scrollLock?.originalPaddingRight || '';
  const originalScrollBehavior = this._scrollLock?.originalScrollBehavior || '';

  // 1) stop any focus-induced scrolling
  if (document.activeElement && typeof document.activeElement.blur === 'function') {
    document.activeElement.blur();
  }

  // 2) force instant scroll behavior for the restore step
  document.documentElement.style.scrollBehavior = 'auto';

  // 3) remove the fixed lock styles
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  document.body.style.overflow = '';
  document.body.style.paddingRight = originalPaddingRight;

  // 4) immediately restore scroll position (no smooth animation)
  window.scrollTo(0, restoreY);

  // 5) restore original scroll-behavior next tick (in case site had smooth scrolling)
  setTimeout(() => {
    document.documentElement.style.scrollBehavior = originalScrollBehavior;
  }, 0);

  // Hide modal (may manage focus internally)
  super.hide();

  // 6) Refocus the opener without scrolling the page into view
  if (!preventFocus && opener && typeof opener.focus === 'function') {
    try {
      opener.focus({ preventScroll: true });
    } catch (_) {
      opener.focus();
    }
  }

  this._scrollLock = null;
}



    preprocessHTML(productElement) {
  productElement.classList.forEach((classApplied) => {
    if (classApplied.startsWith('color-') || classApplied === 'gradient')
      this.modalContent.classList.add(classApplied);
  });
  this.preventDuplicatedIDs(productElement);
  this.removeDOMElements(productElement);
  this.removeGalleryListSemantic(productElement);
  this.updateImageSizes(productElement);
  this.preventVariantURLSwitching(productElement);

  // ✅ ADD THIS: prevent re-running any inline/external scripts inside the fetched snippet
  productElement.querySelectorAll('script').forEach((s) => s.remove());
}


      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
    
  );
}
